/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function MaintenanceRepresentationFromJSON(json) {
    return MaintenanceRepresentationFromJSONTyped(json, false);
}
export function MaintenanceRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        superUser: json['superUser'],
        maintenance: json['maintenance'],
    };
}
export function MaintenanceRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        superUser: value.superUser,
        maintenance: value.maintenance,
    };
}
